import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import ItemType from "../../../types/User"

export interface componentProps {
    item: ItemType
}

const ViewItemGroupLinked: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    const lockingSystemPermissionsCount: number = item.lockingSystemPermissions?.length || 0

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.linked')}</IonItemDivider>
            {item.managedBy &&
                <IonItem lines="full">
                    <IonLabel>{t('common.managed_by')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">{item.managedBy.name || '-'}</IonNote>
                </IonItem>
            }
            <IonItem lines="full">
                <IonLabel>{t('users.users_from_max')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.x_of_y', {
                        x: item.counts?.usersUsed || 0,
                        y: item.maxUsers !== null ? item.maxUsers : '?'
                    })}
                    {(item.counts?.usersReserved || 0) > 0 &&
                        <span> ({t('common.reserved')} {item.counts?.usersReserved})</span>
                    }
                </IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('users.keys_from_max')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.x_of_y', {
                        x: item.counts?.keysUsed || 0,
                        y: item.maxKeys !== null ? item.maxKeys : '?'
                    })}
                    {(item.counts?.keysReserved || 0) > 0 &&
                        <span> ({t('common.reserved')} {item.counts?.keysReserved})</span>
                    }
                </IonNote>
            </IonItem>
            <IonItem lines="full" button={lockingSystemPermissionsCount > 0} detail={lockingSystemPermissionsCount > 0}
                     routerLink={'/users/' + item.id + '/locking-system-permissions'}>
                <IonLabel>{t('locking-system-permissions.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{lockingSystemPermissionsCount || '-'}</IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ViewItemGroupLinked